import React, { useEffect, useState } from 'react';
import './RegisterChildModal.css';
import CommonModal from '@components/common/CommonModal';
import Child from '@assets/svg_main/child.svg';
import Woman from '@assets/svg_main/womanIcon.svg';
import { getChildRegistrationFlows } from '@services/childApiServices';

interface RegisterChildModal {
    showModal: boolean;
    handleDiscard: () => void;
    handleDetailsClick: (key: string, id:any, code:any) => void;
}

const RegisterChildModal: React.FC<RegisterChildModal> = ({ showModal, handleDiscard, handleDetailsClick }) => {
    const [detailsInfo, setDetailsInfo] = useState<any>([]);

    useEffect(() => {
        initialFetch();
    },[]);

    const initialFetch = async () => {
        const response = await getChildRegistrationFlows();
        mapData(response?.data || []);
    }

    const mapData = (data: any) => {
        const mappedDetails = data.map((item: any) => {
                if (item.reg_process_code === "baal_abha_using_parents_details") {
                    return {
                        label: item.reg_process_name,
                        icon: <Woman />,
                        key: 'parent',
                        id: item.reg_process_id,
                        code: item.reg_process_code,
                    }
                } else if (item.reg_process_code === "abha_using_childs_details") {
                    return {
                        label: item.reg_process_name,
                        icon: <Child />,
                        key: 'child',
                        id: item.reg_process_id,
                        code: item.reg_process_code,
                    }
                }
                return null;
            }).filter(Boolean);
            setDetailsInfo(mappedDetails);
    }

    return (
        <CommonModal
            show={showModal}
            handleClose={handleDiscard}
            handleCustomBackButton={handleDiscard}
            showfooter={false}
            showCustomHeader={true}
            conditionalClass='register-child-modal'
            showButtonText={true}
        >
            <div className='details-card-container' >
                <span className='details-title' >Select option to Register Child</span>
                <span className='cards-container' >      
                        {detailsInfo?.map((detail:any) => (
                            <div key={detail.key} className='details-card' onClick={() => handleDetailsClick(detail.key, detail.id, detail.code)} >
                                <span>{detail.icon}</span>
                                <span>{detail.label}</span>
                            </div>
                        ))}
                </span>
            </div>
        </CommonModal>
    )
}

export default RegisterChildModal;